<template>
  <a-card :bordered="false" :loading="loading" v-if="loading"> Loading </a-card>
  <div class="m-position-relative" v-else>
    <a-card>
      <div :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'">
        <div v-if="id === null || id === undefined">
          <a-card class="m-wrong">
            <m-anim
              :options="notfound"
              class="anim"
              :height="getScreen ? 200 : 500"
              :width="getScreen ? 200 : 500"
            ></m-anim>
            <h3>Not Found</h3>
            <label
              >Return to the previous page and make the selection manifest
              again!</label
            >
            <a-button type="primary" block>
              <router-link :to="{ name: 'proyekrab' }">
                <a-icon type="rollback" />&nbsp; Return
              </router-link>
            </a-button>
          </a-card>
        </div>
        <div v-else>
          <a-row :gutter="8">
            <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
              <a-card class="margin-bottom" :loading="loading">
                <div slot="title">Budget Manifest</div>
                <a-popover slot="extra" trigger="click" placement="bottom">
                  <span slot="title">Select Action</span>
                  <ul class="m-list-wrapper bordered" slot="content">
                    <li>
                      <a-button
                        type="primary"
                        style="margin-bottom: 14px"
                        @click="btnExport"
                      >
                        download Excel
                      </a-button>
                    </li>
                  </ul>
                  <a-button icon="more">Action</a-button>
                </a-popover>

                <div v-if="data2.header" class="m-card-body" id="headerId">
                  <ul class="m-list-wrapper bordered">
                    <li>
                      <span class="m-list-title" for>Budget Type</span>
                      <span class="m-list-desc">{{
                        data2.header[0].jenis_anggaran
                          ? "(" +
                            data2.header[0].jns_anggaran_id +
                            ") " +
                            data2.header[0].jenis_anggaran
                          : "-"
                      }}</span>
                    </li>
                    <li>
                      <span class="m-list-title" for>Cost Center Code</span>
                      <span class="m-list-desc">{{
                        data2.header[0].kode_cost_center
                          ? data2.header[0].kode_cost_center
                          : "-"
                      }}</span>
                    </li>
                    <li>
                      <span class="m-list-title" for>Job Name</span>
                      <span class="m-list-desc">{{
                        data2.header[0].nama_pekerjaan
                          ? data2.header[0].nama_pekerjaan
                          : "-"
                      }}</span>
                    </li>
                    <li>
                      <span class="m-list-title" for>Compiler</span>
                      <span class="m-list-desc">{{
                        data2.header[0].penyusun_anggaran
                          ? data2.header[0].penyusun_anggaran
                          : "-"
                      }}</span>
                    </li>
                    <li
                      v-if="
                        'kuasa_anggaran_ga' in data2.header[0] === false &&
                        'kuasa_anggaran_marketing' in data2.header[0] ===
                          false &&
                        'kuasa_anggaran_operasi' in data2.header[0] === false
                      "
                    >
                      <span class="m-list-title" for>Budget Authority</span>
                      <span class="m-list-desc"
                        >{{ data2.header[0].kuasa_anggaran }}
                      </span>
                    </li>
                    <li v-if="'kuasa_anggaran_ga' in data2.header[0]">
                      <span class="m-list-title" for>Budget GA Authority</span>
                      <span class="m-list-desc">{{
                        data2.header[0].kuasa_anggaran_ga
                          ? data2.header[0].kuasa_anggaran_ga
                          : "-"
                      }}</span>
                    </li>
                    <li v-if="'kuasa_anggaran_marketing' in data2.header[0]">
                      <span class="m-list-title" for
                        >Budget Marketing/IBD</span
                      >
                      <span class="m-list-desc">{{
                        data2.header[0].kuasa_anggaran_marketing
                          ? data2.header[0].kuasa_anggaran_marketing
                          : "-"
                      }}</span>
                    </li>
                    <li v-if="'kuasa_anggaran_operasi' in data2.header[0]">
                      <span class="m-list-title" for
                        >Budget Operation Authority</span
                      >
                      <span class="m-list-desc">{{
                        data2.header[0].kuasa_anggaran_operasi
                          ? data2.header[0].kuasa_anggaran_operasi
                          : "-"
                      }}</span>
                    </li>
                    <li>
                      <span class="m-list-title" for>Fiscal Year</span>
                      <span class="m-list-desc">{{
                        data2.header[0].tahun_anggaran
                          ? data2.header[0].tahun_anggaran
                          : "-"
                      }}</span>
                    </li>
                    <li>
                      <span class="m-list-title" for>Revision Number</span>
                      <span class="m-list-desc">{{
                        data2.header[0].revisi_ke
                          ? data2.header[0].revisi_ke
                          : "-"
                      }}</span>
                    </li>
                    <li>
                      <span class="m-list-title" for>Sales Notif Number</span>
                      <span class="m-list-desc">{{
                        data2.header[0].no_notif
                          ? data2.header[0].no_notif
                          : "-"
                      }}</span>
                    </li>
                    <li>
                      <span class="m-list-title" for>Site</span>
                      <span class="m-list-desc">{{
                        data2.header[0].site
                          ? data2.header[0].site
                          : "-"
                      }}</span>
                    </li>
                    <li>
                      <span class="m-list-title" for>Plafon Type</span>
                      <span class="m-list-desc">{{
                        data2.header[0].type_plafon
                          ? data2.header[0].type_plafon
                          : "-"
                      }}</span>
                    </li>
                  </ul>
                </div>
              </a-card>
              <!-- <a-collapse class="margin-top" activeKey="1">
              <a-collapse-panel key="1">
                <h4 slot="header" class="margin-remove">Budget Details</h4>
                <TableAnggaran v-if="genColumn.length>0 && data2.tree.length > 0" :source="data2.tree" :column="genColumn" 
                  :datatree="tree" :listTahun="listThn" />
              </a-collapse-panel>
            </a-collapse> -->
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
              <a-collapse
                :class="getScreen ? 'margin-top' : ''"
                :activeKey="!getScreen ? 1 : 0"
              >
                <a-collapse-panel key="1">
                  <div
                    class="m-display-flex space-between align-middle"
                    slot="header"
                  >
                    <h4 class="margin-remove">Transaction Status</h4>
                    <div v-if="data2.status_app">
                      <Status :status="data2.status_app[0].status" />
                      <a-button
                        @click="historyToggle"
                        type="default"
                        size="small"
                        class="margin-right-small"
                      >
                        <a-icon type="undo" />
                      </a-button>
                    </div>
                  </div>
                  <div style="max-height: 375px;overflow: auto;">
                    <a-timeline class="m-timeline" v-if="data2.status_app">
                      <a-timeline-item color="green">
                        <div class="m-timeline-title">
                          Creator -
                          {{
                            data2.header[0].penyusun_anggaran
                              ? data2.header[0].penyusun_anggaran
                              : "-"
                          }}
                          <!-- Creator - {{ data2.status_app[0].tlc }} -->
                        </div>
                        <div class="m-timeline-body">
                          <h4 class="margin-remove">
                            {{
                              moment(data2.status_app[0].tgl_aksi).format(
                                getDefaultDateFormat
                              )
                            }}
                          </h4>
                          <span
                            class="m-text-small"
                            v-if="data2.status_app[0].catatan"
                            >{{ data2.status_app[0].catatan }}</span
                          >
                          <span class="m-text-small" v-else
                            >Tidak Ada Catatan</span
                          >
                        </div>
                        <div class="m-timeline-footer">
                          <a-tag color="green">Created</a-tag>
                        </div>
                      </a-timeline-item>
                      <a-timeline-item
                        color="green"
                        v-for="(workflow, i) in data2.status_app"
                        :key="workflow.step_no"
                      >
                        <div class="m-timeline-title">
                          {{ workflow.actor }} - {{ workflow.tlc }}
                        </div>
                        <div class="m-timeline-body">
                          <h4
                            class="margin-remove"
                            v-if="workflow.tanggal_aksi !== null"
                          >
                            {{
                              moment(workflow.tanggal_aksi).format(
                                getDateTimeFormat
                              )
                            }}
                          </h4>
                          <span class="m-text-small" v-if="workflow.remark">{{
                            workflow.remark
                          }}</span>
                          <span class="m-text-small" v-else
                            >Tidak Ada Catatan</span
                          >
                        </div>
                        <div class="m-timeline-footer">
                          <Status :status="workflow.status" />
                        </div>
                      </a-timeline-item>
                    </a-timeline>
                  </div>
                </a-collapse-panel>
              </a-collapse>
              <a-collapse class="margin-top margin-bottom" activeKey="1">
                <a-collapse-panel key="1">
                  <div
                    class="m-display-flex space-between align-middle"
                    slot="header"
                  >
                    <h4 class="margin-remove">File Attachment</h4>
                    <div>
                      <a-button
                        :disabled="getAuth.divisi[0] !== 'Akuntansi'"
                        @click="addLampiran"
                        type="default"
                        size="small"
                        class="margin-right-small"
                      >
                        upload
                        <a-icon type="upload" />
                      </a-button>
                    </div>
                  </div>
                  <a-list itemLayout="horizontal" :dataSource="data2.lampiran">
                    <Empty
                      v-if="
                        data2.lampiran
                          ? data2.lampiran.length <= 0
                          : data2.lampiran
                      "
                    />
                    <a-list-item slot="renderItem" slot-scope="item">
                      <a-list-item-meta>
                        <div slot="title">
                          <a
                            @click="handleDownload(item)"
                            class="margin-remove m-text-dots"
                          >
                            {{ item.jenis ? item.jenis : "-" }}
                          </a>
                        </div>
                        <div slot="description">
                          <div class="m-display-flex space-between nowrap">
                            <h4 class="margin-remove m-text-dots">
                              {{ item.fungsi }}
                            </h4>
                            <a-button
                              :disabled="getAuth.divisi[0] !== 'Akuntansi'"
                              @click="
                                handleRemoveExisting(item.id_anggaran_doc)
                              "
                              size="small"
                              type="danger"
                              icon="delete"
                            ></a-button>
                          </div>
                          {{ item.tanggal }} | {{ item.tlc }}
                        </div>
                      </a-list-item-meta>
                    </a-list-item>
                  </a-list>
                </a-collapse-panel>
              </a-collapse>
            </a-col>

            <a-col :xs="{ span: 24 }" :lg="{ span: 8 }"> </a-col>

            <a-modal
              v-model="visibleHistory"
              @ok="historyToggle"
              :footer="null"
            >
              <span slot="title">
                <a-icon type="reload" />&nbsp;History Status
              </span>

              <ul class="m-list-wrapper bordered">
                <li
                  v-for="history in data2.notifikasi"
                  :key="history.id_notifikasi"
                >
                  <div v-if="history.aksi === '1' || history.aksi === '3'">
                    <div class="m-display-flex space-between">
                      <h3 class="margin-remove m-list-title">
                        {{ history.as_from }} | {{ history.tlc_from }}
                      </h3>
                      <Status :status="history.deskripsi" />
                    </div>
                    <span class="m-list-desc">{{
                      moment(history.tgl_notif).format(getDateTimeFormat)
                    }}</span>
                  </div>
                  <div v-else-if="history.aksi === '2' || history.aksi === '4'">
                    <div class="m-display-flex space-between">
                      <h3
                        class="margin-remove m-list-title"
                        v-if="
                          history.aksi === '4' && history.deskripsi === 'Edited'
                        "
                      >
                        {{ history.as_from }} | {{ history.tlc_from }}
                      </h3>
                      <h3 class="margin-remove m-list-title" v-else>
                        {{ history.as_to }} | {{ history.tlc_to }}
                      </h3>
                      <Status :status="history.deskripsi" />
                    </div>
                    <span class="m-list-desc">{{
                      moment(history.tgl_notif).format(getDateTimeFormat)
                    }}</span>
                  </div>
                </li>
              </ul>
            </a-modal>

            <a-modal
              v-model="visibleLampiran"
              @ok="addLampiran"
              :footer="null"
              @cancel="cancelLampiran"
            >
              <span slot="title">
                <a-icon type="reload" />&nbsp;Upload Attachments
              </span>

              <a-form :form="formLampiran">
                <a-form-item label="Document Type">
                  <a-select
                    v-decorator="['jenis', { rules: [{ required: true }] }]"
                  >
                    <!--                  <a-select-option value="COC">COC</a-select-option>-->
                    <!--                  <a-select-option value="Test Report">Test Report</a-select-option>-->
                    <!--                  <a-select-option value="Packing Report">Packing Report</a-select-option>-->
                    <!--                  <a-select-option value="QC Report">QC Report</a-select-option>-->
                    <a-select-option value="Other">Other</a-select-option>
                  </a-select>
                </a-form-item>
                <a-form-item label="Document Description">
                  <a-input
                    autocomplete="off"
                    v-decorator="['fungsi', { rules: [{ required: true }] }]"
                  ></a-input>
                </a-form-item>

                <a-form-item label="Upload Document File">
                  <a-upload
                    :remove="handleRemoveLampiran"
                    v-decorator="[
                      'file_list_lampiran',
                      { rules: [{ required: true }] },
                    ]"
                    :disabled="fileListLampiran.length > 0"
                    :fileList="fileListLampiran"
                    :beforeUpload="beforeUploadLampiran"
                  >
                    <a-button> <a-icon type="upload" />Select File </a-button>
                  </a-upload>
                </a-form-item>

                <a-form-item :wrapper-col="{ span: 24 }">
                  <a-button
                    @click="handleUploadLampiran"
                    block
                    type="danger"
                    html-type="submit"
                    >Save</a-button
                  >
                </a-form-item>
              </a-form>
            </a-modal>
          </a-row>

          <a-row>
            <a-table
                :columns="columnsResume"
                :dataSource="data2.resume"
                :pagination="false"
                :loading="loadingResume"
                rowKey="key"
                bordered
              >
                <span slot="budgeting"
                  >BUDGETING
                  <a-tag>{{ data2.header && data2.header[0] && data2.header[0].kode_cost_center }}</a-tag>
                </span>
                <span slot="title_directorate">
                  DIRECTORATE
                </span>
                <span
                  slot="peruntukan"
                  slot-scope="text, record, index"
                  :class="data2.resume.length - 1 == index ? 'textbold' : ''"
                >
                  {{ text }}
                </span>
                <span
                  :class="data2.resume.length - 1 == index ? 'textbold' : ''"
                  slot="budget"
                  slot-scope="text, record, index"
                >
                  {{ formatCurrency(text.mata_uang, text) }}
                </span>
                <span
                  :class="data2.resume.length - 1 == index ? 'textbold' : ''"
                  slot="realization"
                  slot-scope="text, record, index"
                >
                  {{ formatCurrency(text.mata_uang, text) }}
                </span>
                <span
                  slot="balance"
                  slot-scope="text, record, index"
                  :class="data2.resume.length - 1 == index ? 'textbold' : ''"
                >
                  {{ formatCurrency(text.mata_uang, text) }}
                </span>
              </a-table>
          </a-row>

          <a-row class="margin-top">
            <TableAnggaran
              v-if="genColumn.length > 0 && data2.tree.length > 0"
              :source="data2.tree"
              :column="genColumn"
              :datatree="tree"
              :listTahun="listThn"
              :allowtoEdit="false"
              :headerTitle="headerTitle"
            />
          </a-row>
        </div>
        <a-drawer
          title="Upload Document"
          placement="bottom"
          height="310"
          :closable="false"
          @close="onClose"
          :visible="uploadVisible"
        >
          <a-form :form="form">
            <a-form-item label="Document Description">
              <a-input
                v-decorator="['deskripsi', { rules: [{ required: true }] }]"
              ></a-input>
            </a-form-item>
            <a-form-item label="Upload Document File">
              <a-upload
                :showUploadList="true"
                :fileList="push"
                :beforeUpload="beforeUpload"
                v-decorator="[
                  'upload',
                  { rules: [{ required: true }], valuePropName: 'push' },
                ]"
              >
                <a-button> <a-icon type="upload" />&nbsp;Select File </a-button>
              </a-upload>
            </a-form-item>
            <a-form-item>
              <a-button
                type="primary"
                block
                @click="handleNew"
                :loading="btnLoading"
                >Add</a-button
              >
            </a-form-item>
          </a-form>
        </a-drawer>
      </div>
    </a-card>
  </div>
</template>

<script>
import axios from "axios";
import lottie from "vue-lottie";
import { mapGetters } from "vuex";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import Status from "@/components/Status.vue";
import moment from "moment";
import notfound from "@/assets/anim/404.json";
import HandleRoute from "@/mixins/HandleRoute";
import TableAnggaran from "@/components/TableCustomAnggaran.vue";
import _ from "lodash";

export default {
  name: "manifestAnggaran",
  props: ["id", "budget_thn", "rabview"],
  components: { "m-anim": lottie, TableAnggaran, Status },
  mixins: [CurrencyFormat, HandleRoute],
  data() {
    const columnModal = [
      {
        title: "Deskripsi",
        key: "deskripsi",
        scopedSlots: { customRender: "deskripsi" },
        sorter: (a, b) => a.jenis.length - b.jenis.length,
      },
      {
        title: "Tanggal Buat",
        key: "tanggal",
        dataIndex: "tanggal_buat",
        width: 150,
        sorter: (a, b) =>
          moment(a.tanggal_buat).unix() - moment(b.tanggal_buat).unix(),
      },
      {
        title: "Status",
        key: "status",
        width: 120,
        scopedSlots: { customRender: "status" },
        sorter: (a, b) => a.status.length - b.status.length,
      },
      {
        title: "Value",
        key: "value",
        align: "right",
        scopedSlots: { customRender: "value" },
        sorter: (a, b) => a.value - b.value,
      },
      {
        title: "Realisasi",
        key: "realization",
        align: "right",
        scopedSlots: { customRender: "realization" },
      },
    ];
    const columnRab = [
      {
        title: "Departement",
        key: "title",
        scopedSlots: { customRender: "dataTitle" },
      },
      {
        title: "Total Budget",
        key: "anggaran",
        dataIndex: "anggaran",
        scopedSlots: { customRender: "anggaran" },
      },
      {
        title: "Total Allocation",
        key: "pemakaian",
        dataIndex: "pemakaian",
        scopedSlots: { customRender: "pemakaian" },
      },
      {
        title: "Total Realization",
        key: "realisasi",
        dataIndex: "realisasi",
        scopedSlots: { customRender: "realization" },
      },
      {
        title: "Allocation Budget",
        key: "sisa",
        dataIndex: "sisa",
        scopedSlots: { customRender: "sisa" },
      },
      {
        title: "Realization Budget",
        key: "sisa_realisasi",
        dataIndex: "sisa_realisasi",
        scopedSlots: { customRender: "trealization" },
      },
    ];
    const columnsResume = [
      {
        slots: { title: "budgeting" },
        key: "peruntukan",
        dataIndex: "peruntukan",
        scopedSlots: { customRender: "peruntukan" },
      },
      {
        slots: { title: 'title_directorate' },
        key: "directorate",
        dataIndex: "direktorat",
        align: "left",
      },
      {
        title: "BUDGET",
        key: "budget",
        dataIndex: "budget",
        align: "right",
        scopedSlots: { customRender: "budget" },
      },
      {
        title: "REALIZATION",
        key: "realization",
        dataIndex: "realization",
        align: "right",
        scopedSlots: { customRender: "realization" },
      },
      {
        title: "BALANCE",
        key: "balance",
        dataIndex: "balance",
        align: "right",
        scopedSlots: { customRender: "balance" },
      },
    ];
    return {
      loading: true,
      loadingModal: true,
      loadingResume: false,
      btnLoading: false,
      notfound: { animationData: notfound, loop: true },
      data: {},
      data2: {},
      uploadVisible: false,
      push: [],
      search: "",
      pagination: {
        onChange: (page) => {},
        pageSize: 5,
        size: "small",
      },
      rabVisibleDtl: false,
      dataRabVisibleDtl: {
        title: "",
        data: {
          pengeluran: "",
        },
      },
      columnsResume,
      columnRab,
      columnModal,
      isRabExist: true,
      genColumn: [],
      listThn: { dtl: [], rekap: [] },
      tree: [],
      visibleHistory: false,
      visibleLampiran: false,
      fileListLampiran: [],
      headerTitle: {},
      json_fields: {
        "Complete name": "name",
        City: "city",
        Telephone: "phone.mobile",
        "Telephone 2": "phone.landline",
      },
      json_data: [
        {
          name: "Tony Peña",
          city: "New York",
          country: "United States",
          birthdate: "1978-03-15",
          phone: {
            mobile: "1-541-754-3010",
            landline: "(541) 754-3010",
          },
        },
        {
          name: "Thessaloniki",
          city: "Athens",
          country: "Greece",
          birthdate: "1987-11-23",
          phone: {
            mobile: "+1 855 275 5071",
            landline: "(2741) 2621-244",
          },
        },
      ],

      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
    };
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getIsSpecialMenu",
      "getDateTimeFormat",
      "getDefaultDateFormat",
    ]),
    searchbox() {
      let data = this.dataRabVisibleDtl.data.pengeluaran;

      if (this.search) {
        data = _.filter(
          data,
          (value) =>
            (value.jenis ? value.jenis : "")
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0 ||
            (value.status ? value.status : "")
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0 ||
            (value.no ? value.no : "")
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0 ||
            (value.value ? value.value : "").indexOf(
              this.search.toLowerCase()
            ) >= 0 ||
            (value.realisasi ? value.realisasi : "").indexOf(
              this.search.toLowerCase()
            ) >= 0 ||
            this.moment(value.tanggal_buat)
              .format(this.getDefaultDateFormat)
              .toString()
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0
        );
      }

      let totalallocation = 0;
      let totalrealisasi = 0;

      if (data) {
        data.forEach((list) => {
          totalallocation = totalallocation + parseFloat(list.value);
          totalrealisasi =
            totalrealisasi + parseFloat(list.realisasi ? list.realisasi : 0);
        });
      }

      return { data, totalallocation, totalrealisasi };
    },
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
    this.formLampiran = this.$form.createForm(this);
  },
  created() {
    this.fetchManifest();
  },
  watch: {
    id() {
      if (this.id) {
        this.fetchManifest();
      }
    },
  },
  methods: {
    moment,
    async fetchManifest() {
      this.loading = false;

      await axios({
        method: "get",
        url: this.$serviceUrl + "anggaran/manifest1",
        params: {
          tlc: this.getAuth.username,
          anggaran_id: this.id,
          tahun: this.budget_thn,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.data2 = response.data;
          if (this.data2) {
            this.data2.header[0].available = false;
            this.headerTitle = this.data2.header;
          }
          this.loading = false;

          this.fetchresume();
        })
        .catch((err) => {
          if (!err.response) {
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error", responses);
            this.$router.go(-1);
          } else {
            this.displayMessage("denied-manifest");
            this.$router.push({ name: "beranda" });
          }
        });
      this.generateColumn();
    },
    fetchresume(){
      this.loadingResume = true;
      axios({
        method: "get",
        url: this.$serviceUrl + "anggaran/resume",
        params: {
          anggaran_id: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
      .then((response) => {
        this.data2.resume = response.data.resume
        this.data2.resume.forEach((element,index)=>{
          this.data2.resume[index]['key'] = index;
        });
        this.loadingResume = false;
      })
      .catch(() => {
        this.loadingResume = false;
      })
    },
    handleCancel() {
      this.previewVisible = false;
    },
    handleViewDokumen(file) {
      const url = this.$serviceUrl + file.url;
      window.open(url, "_blank");
    },
    showDrawer() {
      this.uploadVisible = true;
    },
    onClose() {
      this.uploadVisible = false;
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        this.push = [file];
        return false;
      }
    },
    handleNew() {
      this.confirmMessage("confirm-save");
    },
    handleNewProcess() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.btnLoading = false;
          this.displayMessage("form-warning");
          return;
        }

        let addData = new FormData();
        addData.append("kode_proyek", this.id);
        addData.append("deskripsi_doc", values.deskripsi);
        addData.append("tlc", this.getAuth.username);
        addData.append("file_transfer", this.push[0]);

        this.btnLoading = true;
        axios({
          method: "post",
          url: this.$serviceUrl + "project/doc_closing",
          processData: false,
          data: addData,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "multipart/form-data",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then(() => {
            this.btnLoading = false;
            this.uploadVisible = false;
            this.fetchManifest();
          })
          .catch((err) => {
            console.log("error : " + err);
          });
      });
    },
    handleRemove(item) {
      this.confirmMessageValue("confirm-delete", item);
    },
    delete(item) {
      const serviceUrl = this.$serviceUrl;
      const auth = {
        username: this.getAuth.username,
        password: this.getAuth.password,
        apikey: this.getAuth.apikey,
      };
      axios({
        method: "delete",
        url: serviceUrl + "project/doc_closing",
        processData: false,
        data: {
          id_project_doc: item,
        },
        auth: {
          username: auth.username,
          password: auth.password,
        },
        headers: {
          "X-API-KEY": auth.apikey,
        },
      })
        .then((response) => {
          Event.$emit("refresh", true);
        })
        .catch((err) => {
          console.log("error : " + err);
        });
    },
    handleDownload(item) {
      window.open(this.$serviceUrl + item.url, "_blank");
    },
    handleClose() {
      this.confirmMessage("confirm-close");
    },
    close() {
      if (this.data.dokumen_closing.length >= 1) {
        const serviceUrl = this.$serviceUrl,
          auth = {
            username: this.getAuth.username,
            password: this.getAuth.password,
            apikey: this.getAuth.apikey,
          },
          data = new FormData();

        data.append("tlc", auth.username);
        data.append("kode_proyek", this.id);
        axios({
          method: "post",
          url: serviceUrl + "project/closing",
          processData: false,
          data: data,
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
          },
        })
          .then((response) => {
            this.displayMessage("success-close-project");
            this.$router.go();
          })
          .catch((err) => {
            console.log("error : " + err);
          });
      } else {
        this.displayMessage("warning-emptyDoc");
      }
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    hideModal() {
      this.toggleBodyClass("removeClass", "scrollDisable");
      this.rabVisibleDtl = false;
    },
    visibleDtlToggle(item) {
      this.loadingModal = true;
      this.toggleBodyClass("addClass", "scrollDisable");

      axios({
        method: "get",
        url: this.$serviceUrl + "project/detil_rab",
        params: {
          kode_proyek: this.id,
          allocation: item.toLowerCase(),
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          let items = {
            title: item,
            data: JSON.parse(JSON.stringify(response.data)),
          };
          this.dataRabVisibleDtl = items;
          this.loadingModal = false;
        })
        .catch((err) => {
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error", responses);
        });
      this.rabVisibleDtl = true;
    },
    historyToggle(e) {
      e.stopPropagation();
      this.visibleHistory = !this.visibleHistory;
    },
    addLampiran(e) {
      e.stopPropagation();
      this.visibleLampiran = !this.visibleLampiran;
    },
    beforeUploadLampiran(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        this.fileListLampiran.push(file);
        return false;
      }
    },
    handleRemoveExisting(id) {
      this.confirmMessageValue("confirm-delete", id);
    },
    handleRemoveLampiran(file) {
      const index = this.fileListLampiran.indexOf(file);
      const newFileList = this.fileListLampiran.slice();
      newFileList.splice(index, 1);
      this.fileListLampiran = newFileList;
    },
    executeRemoveLampiran(id) {
      const serviceUrl = this.$serviceUrl;
      const auth = {
        username: this.getAuth.username,
        password: this.getAuth.password,
        apikey: this.getAuth.apikey,
      };

      axios({
        method: "delete",
        url: serviceUrl + "anggaran/lampiran",
        processData: false,
        data: {
          id_anggaran_doc: id,
        },
        auth: {
          username: auth.username,
          password: auth.password,
        },
        headers: {
          "X-API-KEY": auth.apikey,
        },
      })
        .then((response) => {
          this.$router.go();
          //Event.$emit("refresh", true);
          if (response.data.message === "Delete Success") {
            this.displayMessage("success-del");
          } else {
            let responses = Object.assign({}, response.data);
            this.displayMessageValue("error", responses);
          }
        })
        .catch((err) => {
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error", responses);
        });
    },
    cancelLampiran() {
      this.fileListLampiran = [];
      this.formLampiran.resetFields();
    },
    handleUploadLampiran() {
      this.formLampiran.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        let formData = new FormData();
        formData.append("id_manifest", this.id);
        formData.append("fungsi", values.fungsi);
        formData.append("jenis", values.jenis);
        formData.append("tlc", this.getAuth.username);
        formData.append("nama_document", values.file_list_lampiran.file);

        axios({
          method: "post",
          url: this.$serviceUrl + "anggaran/upload_lampiran",
          processData: false,
          data: formData,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.displayMessage("success-upload");
            this.visibleLampiran = !this.visibleLampiran;
            //Event.$emit("refresh", true);
            this.$router.go();
          })
          .catch((err) => {
            console.log("error : " + err);
          });
      });
    },

    generateColumn() {
      let rangethn = [];
      let lop = 0;
      var gencolm = [];

      //colom title item / cost center
      gencolm = [
        {
          slots: { title: "customTitleMain" },
          key: "name",
          width: 300,
          fixed: "left",
          showcolumn: "",
          scopedSlots: { customRender: "name" },
        },
      ];
      //colom header all tahun
      gencolm.push({
        key: "alltahun",
        slots: { title: "customTitleAllTahun" },
        scopedSlots: { customRender: "alltahun" },
        dataIndex: "rangetahun",
        align: "left",
        children: [],
      });
      this.data2.tahun.forEach((item) => {
        rangethn[lop] = item["tahun"];

        //detil
        var dtljson = {
          title: "Year " + item["tahun"],
          scopedSlots: { customRender: "tahun" },
          className: "unhide header th" + item["tahun"],
          children: [
            {
              title: "Code Budget",
              width: 150,
              dataIndex: "kode_anggran" + item["tahun"],
              key: "code" + item["tahun"] + "1",
              align: "left",
              className: "fix th" + item["tahun"],
              scopedSlots: { customRender: "dtlitemcode" },
            },
            {
              title: "Unit",
              width: 50,
              dataIndex: "jumlah" + item["tahun"],
              key: "jumlah" + item["tahun"] + "1",
              align: "center",
              className: "fix th" + item["tahun"],
              //scopedSlots: { customRender: ('dtlitem01') }
            },
            {
              title: "unit price",
              width: 150,
              dataIndex: "harga_satuan" + item["tahun"],
              key: "harga_satuan" + item["tahun"] + "1",
              align: "right",
              className: "fix th" + item["tahun"],
              scopedSlots: { customRender: "dtlitemprice" },
            },
            {
              title: "Jan'" + item["tahun"].substr(2),
              width: 150,
              dataIndex: "bln" + item["tahun"] + "1",
              key: "bln" + item["tahun"] + "1",
              align: "right",
              className: "unhide th" + item["tahun"],
              scopedSlots: { customRender: "dtlitem01" },
            },
            {
              title: "Feb'" + item["tahun"].substr(2),
              width: 150,
              dataIndex: "bln" + item["tahun"] + "2",
              key: "bln" + item["tahun"] + "2",
              align: "right",
              className: "unhide th" + item["tahun"],
              scopedSlots: { customRender: "dtlitem02" },
            },
            {
              title: "Mar'" + item["tahun"].substr(2),
              width: 150,
              dataIndex: "bln" + item["tahun"] + "3",
              key: "bln" + item["tahun"] + "3",
              align: "right",
              className: "unhide th" + item["tahun"],
              scopedSlots: { customRender: "dtlitem03" },
            },
            {
              title: "Apr'" + item["tahun"].substr(2),
              width: 150,
              dataIndex: "bln" + item["tahun"] + "4",
              key: "bln" + item["tahun"] + "4",
              align: "right",
              className: "unhide th" + item["tahun"],
              scopedSlots: { customRender: "dtlitem04" },
            },
            {
              title: "May'" + item["tahun"].substr(2),
              width: 150,
              dataIndex: "bln" + item["tahun"] + "5",
              key: "bln" + item["tahun"] + "5",
              align: "right",
              className: "unhide th" + item["tahun"],
              scopedSlots: { customRender: "dtlitem05" },
            },
            {
              title: "Jun'" + item["tahun"].substr(2),
              width: 150,
              dataIndex: "bln" + item["tahun"] + "6",
              key: "bln" + item["tahun"] + "6",
              align: "right",
              className: "unhide th" + item["tahun"],
              scopedSlots: { customRender: "dtlitem06" },
            },
            {
              title: "Jul'" + item["tahun"].substr(2),
              width: 150,
              dataIndex: "bln" + item["tahun"] + "7",
              key: "bln" + item["tahun"] + "7",
              align: "right",
              className: "unhide th" + item["tahun"],
              scopedSlots: { customRender: "dtlitem07" },
            },
            {
              title: "Aug'" + item["tahun"].substr(2),
              width: 150,
              dataIndex: "bln" + item["tahun"] + "8",
              key: "bln" + item["tahun"] + "8",
              align: "right",
              className: "unhide th" + item["tahun"],
              scopedSlots: { customRender: "dtlitem08" },
            },
            {
              title: "Sep'" + item["tahun"].substr(2),
              width: 150,
              dataIndex: "bln" + item["tahun"] + "9",
              key: "bln" + item["tahun"] + "9",
              align: "right",
              className: "unhide th" + item["tahun"],
              scopedSlots: { customRender: "dtlitem09" },
            },
            {
              title: "Okt'" + item["tahun"].substr(2),
              width: 150,
              dataIndex: "bln" + item["tahun"] + "10",
              key: "bln" + item["tahun"] + "10",
              align: "right",
              className: "unhide th" + item["tahun"],
              scopedSlots: { customRender: "dtlitem10" },
            },
            {
              title: "Nov'" + item["tahun"].substr(2),
              width: 150,
              dataIndex: "bln" + item["tahun"] + "11",
              key: "bln" + item["tahun"] + "11",
              align: "right",
              className: "unhide th" + item["tahun"],
              scopedSlots: { customRender: "dtlitem11" },
            },
            {
              title: "Des'" + item["tahun"].substr(2),
              width: 150,
              dataIndex: "bln" + item["tahun"] + "12",
              key: "bln" + item["tahun"] + "12",
              align: "right",
              className: "unhide th" + item["tahun"],
              scopedSlots: { customRender: "dtlitem12" },
            },
            {
              title: "Sub Total",
              dataIndex: "rekap" + item["tahun"],
              key: "rekap" + item["tahun"],
              align: "right",
              className: "unhide th" + item["tahun"],
              scopedSlots: { customRender: "dtlitemrekap" },
            },
          ],
        };

        //rekap
        var dtljson2 = {
          title: "Year " + item["tahun"],
          className: "hide header th" + item["tahun"] + "rekap kolom",
          width: 150,
          children: [
            {
              title: "Code Budget",
              width: 150,
              dataIndex: "kode_anggran" + item["tahun"],
              key: "rekcode" + item["tahun"] + "1",
              align: "center",
              className: "hide th" + item["tahun"] + "rekap kolom",
              scopedSlots: { customRender: "dtlitemcode" },
            },
            {
              title: "Unit",
              width: 50,
              dataIndex: "jumlah" + item["tahun"],
              key: "rekjumlah" + item["tahun"] + "1",
              align: "right",
              className: "hide th" + item["tahun"] + "rekap kolom",
              //scopedSlots: { customRender: ('dtlitem01') }
            },
            {
              title: "unit price",
              width: 150,
              dataIndex: "harga_satuan" + item["tahun"],
              key: "rekharga_satuan" + item["tahun"] + "1",
              align: "right",
              className: "hide th" + item["tahun"] + "rekap kolom",
              scopedSlots: { customRender: "dtlitemprice" },
            },
            {
              title: "Sub Total",
              dataIndex: "rekap" + item["tahun"],
              key: "rekrekap" + item["tahun"],
              align: "right",
              width: 150,
              className: "hide th" + item["tahun"] + "rekap kolom",
              scopedSlots: { customRender: "dtlitemrekap" },
            },
            {
              title: "",
              dataIndex: "",
              key: "relative",
              align: "right",
              className: "hide th" + item["tahun"] + "rekap kolom",
            },
          ],
        };
        //push ke variable generate top root
        gencolm[1].children.push(dtljson2);
        gencolm[1].children.push(dtljson);
        lop++;
      });

      //rekap allrange tahun
      var rkpjson = {
        slots: { title: "customTitleTahun" },
        scopedSlots: { customRender: "tahun" },
        className: "unhide alltahun",
        children: [
          {
            title: "Grand Total",
            dataIndex: "rekapalltahun",
            key: "rekapalltahun",
            align: "right",
            float: "left",
            width: 150,
            className: "relative",
            scopedSlots: { customRender: "dtlitemrekap" },
          },
          {
            title: "",
            dataIndex: "",
            key: "rekaprelative",
            align: "right",
            className: "relative",
          },
        ],
      };
      gencolm[1].children.push(rkpjson);

      // var rkpjson3 = {
      //     title: '' ,
      //     className: "relative",
      //     children: [
      //       {
      //         title: '',
      //         dataIndex: '',
      //         key: 'relative',
      //         align: 'right',
      //         float: "left",
      //         className: "relative",
      //       },
      //     ],
      //   };
      // gencolm[1].children.push(rkpjson3);

      this.listThn.dtl = rangethn;
      this.listThn.rekap = rangethn;
      this.genColumn = gencolm;
    },
    btnExport(table, name) {
      this.data2.header[0].available = true;
      this.headerTitle = this.data2.header;

      let jns_anggaran = this.headerTitle[0].jenis_anggaran;

      this.headerTitle[0].jenis_anggaran = "";
      this.headerTitle[0].jenis_anggaran = jns_anggaran;

      // setTimeout(() => { this.data2.tree}, 3000);
      setTimeout(() => {
        let uri = "data:application/vnd.ms-excel;base64,",
          template =
            '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/><style>td {border:thin solid black;};table {border-collapse:collapse}</style></head><body><table>{table}</table></body></html>',
          base64 = function (s) {
            return window.btoa(unescape(encodeURIComponent(s)));
          },
          format = function (s, c) {
            return s.replace(/{(\w+)}/g, function (m, p) {
              return c[p];
            });
          };
        if (!table.nodeType)
          table = document.getElementsByClassName("ant-table-scroll");
        let h = document.getElementsByClassName("ant-table-title");
        let ctx = {
          worksheet: name || "Worksheet",
          table: h[0].innerHTML + table[0].innerHTML,
        };
        let a = document.createElement("a");
        a.href = uri + base64(format(template, ctx));
        a.download = "Budget.xls";
        a.click();

        this.$router.go();
      }, 3000);
    },
  },
  mounted() {
    this.toggleBodyClass("removeClass", "scrollDisable");
    Event.$on("refresh", this.fetchManifest);
    Event.$on("confirmMessageDelete", this.delete);
    Event.$on("confirmMessageClose", this.close);
    Event.$on("confirmMessageReturn", this.handleNewProcess);
    Event.$on("confirmMessageDelete", this.executeRemoveLampiran);
  },
  beforeDestroy() {
    this.toggleBodyClass("removeClass", "scrollDisable");
    Event.$off("refresh", this.fetchManifest);
    Event.$off("confirmMessageDelete", this.delete);
    Event.$off("confirmMessageClose", this.close);
    Event.$off("confirmMessageReturn", this.handleNewProcess);
    Event.$off("confirmMessageDelete", this.executeRemoveLampiran);
  },
};
</script>

<style lang="less">
.ant {
  &-modal {
    top: 12px !important;
  }
  &-table {
    &-footer {
      padding: 0;
    }
  }
  &-list-item {
    &-content {
      margin-bottom: 0 !important;
    }
  }
}
.m-price-total {
  margin: 0 !important;
  text-align: right;

  &.mobile {
    .ant-statistic-content {
      font-size: 14px;
      font-weight: 600;
    }
  }
}
.textbold {
  font-weight: bold;
}
</style>
